import React, { useState, useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Container from '@material-ui/core/Container';
import logo from '../../assets/images/tcn-logo.svg';
import Footer from '../../components/Footer';
import validateForm from './validateForm.helper';
import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined';

import Notify from '../../components/notify';
import Loader from '../../components/loader';
import { setAuthToken, setIdToken, getMfaToken, removeMfaToken, getApplyAgentIssuanceOnly } from '../../helpers/localStorage';
import { otpVerifyAPI } from '../../services/api';

export default function OneTimePasswordVerify() {
  const { search } = useLocation();

  const searchParams = useMemo(() => new URLSearchParams(search), [search]);

  const [openNotification, setOpenNotify] = useState(false);
  const [code, setCode] = useState(searchParams.get('code') || '');
  const [validationErrors, setValidationErrors] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const mfaToken = getMfaToken();
    if (!mfaToken) {
      history.push('/login');
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = { code };
    const validate = validateForm(payload);
    if (validate.hasError) {
      setValidationErrors(validate);
      return;
    }
    setLoading(true);

    try {
      const res = await otpVerifyAPI(payload);

      setLoading(false);
      setAuthToken(res.auth_token);
      setIdToken(res.id_token);
      removeMfaToken();

      await getApplyAgentIssuanceOnly()
        ? history.push('/agent-issuance')
        : history.push('/dashboard');
    }
    catch (err) {
      setErrors(err);
      setLoading(false);
      setOpenNotify(true);
    };
  };

  return (
    <>
      <Container
        component="main"
        className="forget-password-container flex-col container"
      >
        <CssBaseline />
        <div className="flex flex-col items-center forget-password-wrapper">
          <Avatar className="avatar">
            <img src={logo} alt="login-logo"></img>
          </Avatar>
          <form
            className="forget-password-form"
            noValidate
            onSubmit={handleSubmit}
          >
            <TextField
              error={validationErrors.email}
              required
              fullWidth
              id="code"
              label="Enter your one-time password"
              name="code"
              value={code}
              autoFocus
              onChange={(e) => setCode(e.target.value)}
              className="login-field"
              helperText="*Is required."
            />
            <Button
              type="submit"
              fullWidth
              className="submit-btn"
              disabled={loading}
              endIcon={
                <ArrowForwardOutlinedIcon style={{ color: '#FFFB00' }} />
              }
            >
              Login
            </Button>
          </form>
        </div>
      </Container>
      <Footer />
      <Notify
        open={openNotification}
        onClose={() => setOpenNotify(false)}
        errors={errors}
        successMessage="Invalid one-time password"
      />
      <Loader loading={loading} />
    </>
  );
};
